<template>
    <div class="card-personal-information">
        <v-icon v-on:click="dropClient()">fa-times</v-icon>
        <div class="card-info-row">
            <div class="card-info avatar">
                <div class="card-avatar">{{ customer.name ? customer.name.substring(0,1).toUpperCase() : "" }}</div>
                <div class="card-info">
                    <label for=""><b>Nome</b></label>
                    <p class="card-name" @click="editClient">{{ customer.name ? customer.name : "Não Informado" }}</p>
                    <span>
                        {{ customer.federalId | fmtCPF }}
                        <v-icon size="small" v-on:click="copyText(customer.federalId, $event)">fas fa-copy</v-icon>
                    </span>
                </div>
            </div>
        </div>
        <div class="card-info-row">
            <div class="card-info">
                <label for=""><b>Idade</b></label>
                {{ customer.birth | moment('DD/MM/YYYY') }} ({{ customer.age }} anos)
            </div>
            <div class="card-info">
                <label for=""><b>Cidade</b></label>
                <p>{{customer.city}} - {{customer.state}}</p>
            </div>
        </div>
        <div class="card-info-row">
            <div class="card-info">
                <label for=""><b>CEP</b></label>
                <span>
                    {{ customer.zipcode ? customer.zipcode : 'Não informado' }}
                    <v-icon v-if="customer.zipcode" size="small" v-on:click="copyText(customer.zipcode, $event)">fas fa-copy</v-icon>
                </span>
            </div>
            <div class="card-info">
                <label for=""><b>Telefone</b></label>
                <span>
                    {{ customer.phone }}
                    <a target="_blank" :href="currentWaLink">
                        <v-icon small>fab fa-whatsapp</v-icon>
                    </a>
                </span>
            </div>
        </div>
        <div class="card-info-row" v-if="customer.representativeName || customer.representativeFederalId || customer.representativeBirth">
            <div class="legal-representative-container">
                <p>Representante Legal</p>
                <div class="card-info-row">
                    <div class="card-info">
                        <label for=""><b>Nome</b></label>
                        {{ customer.representativeName}}
                    </div>
                </div>
                <div class="card-info-row">
                    <div class="card-info">
                        <label for=""><b>CPF</b></label>
                        {{ customer.representativeFederalId | fmtCPF }}
                    </div>
                    <div class="card-info">
                        <label for=""><b>Nascimento</b></label>
                        <p>{{customer.representativeBirth | moment('DD/MM/YYYY')}}</p>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        customer: {
            type: Object,
            required: true
        },
        benefitTypes: {
            type: Array,
            required: true
        },
        selectedEnrollment: {
            type: String,
            required: false
        },
        dropClient: {
            type: Function,
            required: true
        },
        editClient: {
            type: Function,
            required: true
        },
    },

    computed: {
        currentWaLink() {
            return `https://wa.me/+55${this.customer.phone}`;
        },
    },

    methods: {
        copyText(text, event) {
			event.preventDefault();
			event.stopPropagation();

			window.Clipboard.copy(text);

			this.$notifyUser({
				message: 'Texto Copiado!'
			});
		},
    }
}
</script>

<style scoped>
    p {
        margin: 0;
        padding: 0;
    }

    .card-personal-information {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 15px;
        border-radius: 5px;
        background-color: var(--white-color);
        position: relative;
        gap: 10px;
    }

    .card-personal-information > i {
        position: absolute;
        top: 15px;
        right: 15px;
        cursor: pointer;
    }

    .card-info {
        display: flex;
        flex-direction: column;
    }

    .card-info > label {
        font-size: 12px;
        color: var(--gray-color);
    }

    .card-info.avatar {
        flex-direction: row;
        align-items: flex-start;
    }

    .card-info-row {
        display: flex;
        flex-direction: row;
        gap: 20px;
    }

    .card-avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: var(--primary-color);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 22px;
        font-weight: bold;
        color: var(--white-color);
        margin-right: 10px;
    }

    .card-name {
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        color: var(--primary-color);
    }

    .card-name:hover {
        color: var(--primary-color-hover);
    }


    .card-info span {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
    }

    .card-brand-image {
        height: 40px;
        object-fit: contain;
    }

    .legal-representative-container {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 5px;
        background-color: #003f9e18;
        padding: 10px;
        border-radius: 5px;
    }

    .legal-representative-container > p {
        font-size: 12px;
        color: #A8A8A8;
    }
</style>


// WEBPACK FOOTER //
// src/components/Prospection/Cards/ClientCard.vue